import React, { useRef } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { disRememberResetApi } from "../../../api";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./LoginFlat.css";

const ForgotPasswordSecondComp = (props) => {
  const { t } = useTranslation();
  const form = useRef(null);
  const initialLoginValues = {
    token: "",
    email: "",
    new_password: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    disRememberResetApi(data).then((res) => {
      props.history.push("/login");
    });
  };

  const validationSchemaLogin = Yup.object({
    token: Yup.string().required(t("کد را وارد کنید.")),
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
    new_password: Yup.string().required(t("رمز عبور جدید را وارد کنید.")),
  });

  return (
    <>
      {/* Header Section */}
      <div className="login-flat-header">
        <div className="login-flat-icon-wrapper">
          <svg className="login-flat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="currentColor"/>
          </svg>
        </div>
        <h2 className="login-flat-title">{t("رمز عبور خود را تنظیم کنید")}</h2>
        <p className="login-flat-subtitle">
          {t("کد به ایمیل شما ارسال شد")}
          <br />
          {t("لطفا کد را وارد کرده و گذرواژه جدیدی ایجاد کنید")}.
        </p>
      </div>
      
      {/* Form Section */}
      <div className="login-flat-form">
        <Formik
          initialValues={initialLoginValues}
          onSubmit={submitLoginForm}
          validationSchema={validationSchemaLogin}
        >
          {(props) => (
            <Form ref={form}>
              {/* Token Input */}
              <div className="login-flat-input-group">
                <div className="login-flat-input-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.65 10C11.7 7.31 8.9 5.5 5.77 6.12C3.48 6.58 1.62 8.41 1.14 10.7C0.32 14.57 3.26 18 7 18C9.61 18 11.83 16.33 12.65 14H16.92C17.65 14 18.29 13.48 18.45 12.77L19.43 8.52C19.68 7.45 18.84 6.5 17.74 6.5H12.03C12.01 6.67 12 6.83 12 7C12 8.11 12.25 9.16 12.65 10ZM7 16C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8C9.21 8 11 9.79 11 12C11 14.21 9.21 16 7 16Z" fill="currentColor"/>
                  </svg>
                </div>
                <input
                  type="number"
                  name="token"
                  placeholder={t("کد")}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  className="login-flat-input"
                />
                <ErrorMessage name="token">
                  {(errMsg) => (
                    <div className="login-flat-error">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              
              {/* Email Input */}
              <div className="login-flat-input-group">
                <div className="login-flat-input-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                  </svg>
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder={t("ایمیل")}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  className="login-flat-input"
                />
                <ErrorMessage name="email">
                  {(errMsg) => (
                    <div className="login-flat-error">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              
              {/* New Password Input */}
              <div className="login-flat-input-group">
                <div className="login-flat-input-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z" fill="currentColor"/>
                  </svg>
                </div>
                <input
                  type="password"
                  name="new_password"
                  placeholder={t("رمز عبور جدید")}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  className="login-flat-input"
                />
                <ErrorMessage name="new_password">
                  {(errMsg) => (
                    <div className="login-flat-error">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              
              <button type="submit" className="login-flat-button">
                {t("ورود")}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

const ForgotPasswordSecond = withRouter(ForgotPasswordSecondComp);

export { ForgotPasswordSecond };
